import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function NovedadesEnvioCProblemas() {
  return (
    <ClipperPlaceholder title="Envío c/ Problemas" category="Novedades" />
  );
}
